<template>
  <div>
    <OverviewComponent
      icon="mdi-order-bool-ascending-variant"
      :subtitle="subtitle"
      :headers="headers"
      :data="data"
      :loading="loading"
      :totalPages="totalPages"
      :totalItemCount="totalItemCount"
      :defaultSortBy="defaultSortBy"
      :defaultSortDesc="defaultSortDesc"
      @setHeader="setHeader"
      @fetchData="fetchData"
      @setColor="setColor"
      @click="clickCard"
    >
      <template v-slot:headlineBtns>
        <v-btn class="mr-3" color="primary" @click="addChecklist">
          Legg til sjekkliste
        </v-btn>
      </template>

      <template v-slot:btnMobile>
        <div>
          <v-btn class="mt-2" color="primary" block @click="addChecklist">
            Legg til sjekkliste
          </v-btn>
        </div>
      </template>

      <template v-slot:chips="{ item }">
        <div v-for="(chip, index) in getChips(item)" :key="index">
          <v-chip class="mr-2" :color="chip.color" small>
            {{ chip.title }}
          </v-chip>
        </div>
      </template>

      <template v-slot:underLeft="{ item }">
        {{ item.projectName }}
        {{
          item.projectName && (item.projSectionApartNum || item.houseName)
            ? "-"
            : ""
        }}
        {{
          item.projSectionApartNum ? item.projSectionApartNum : item.houseName
        }}
      </template>

      <!-- Custom filter -->
      <template v-slot:filter.projectName="{ head, isTable }">
        <v-autocomplete
          v-if="!head.removeFilter"
          :class="{ 'mb-0': isTable }"
          v-model="head.filterValues"
          :items="isTrysilhus ? projects : projects"
          :filled="!isTable"
          :outlined="isTable"
          :dense="isTable"
          :label="isTable ? '' : head.text"
          :placeholder="isTable ? 'Søk...' : ''"
          item-text="name"
          item-value="id"
          clearable
          :disabled="head.disabled"
          hide-details="auto"
          menu-props="auto"
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.name }}</span>
            <span v-if="index === 1" class="grey--text text-caption">
              &nbsp;(+{{ head.filterValues.length - 1 }} andre)
            </span>
          </template>
        </v-autocomplete>
      </template>
      <!-- <template v-slot:filter.name="{ head }"> {{ head.value }} </template> -->
      <!-- <template v-slot:filter.assignedTo="{ head, isTable }">
        <v-autocomplete
          :class="{ 'mb-0': isTable }"
          v-model="head.filterValues"
          :items="contactPersons"
          :filled="!isTable"
          :outlined="isTable"
          :dense="isTable"
          :label="isTable ? '' : 'Ansvarlig'"
          :placeholder="isTable ? 'Ansvarlig' : ''"
          item-text="name"
          item-value="id"
          clearable
          :disabled="head.disabled"
          hide-details="auto"
        ></v-autocomplete>
      </template> -->
      <template v-slot:filter.assignedTo="{ head, isTable }">
        <v-autocomplete
          :class="{ 'mb-0': isTable }"
          v-model="head.filterValues"
          :items="users"
          :filled="!isTable"
          :outlined="isTable"
          :dense="isTable"
          :label="isTable ? '' : 'Ansvarlig'"
          :placeholder="isTable ? 'Ansvarlig' : ''"
          item-text="value"
          item-value="key"
          clearable
          :disabled="head.disabled"
          hide-details="auto"
        ></v-autocomplete>
      </template>
      <template v-slot:filter.tradeCodeName="{ head, isTable }">
        <v-autocomplete
          :class="{ 'mb-0': isTable }"
          v-model="head.filterValues"
          :items="tradeCodes"
          :filled="!isTable"
          :outlined="isTable"
          :dense="isTable"
          :label="isTable ? '' : 'Fagområde'"
          :placeholder="isTable ? 'Fagområde' : ''"
          item-text="name"
          item-value="id"
          clearable
          :disabled="head.disabled"
          hide-details="auto"
        ></v-autocomplete>
      </template>
    </OverviewComponent>

    <AddChecklistDialog
      v-model="showAddChecklist"
      icon="mdi-home"
      title="Legg til sjekkliste"
      :users="users"
      :projectId="checklistProjectId"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";
import { HeaderObject } from "@/types/tableInterface";
import checkListApi from "@/api/checkListApi";

import OverviewComponent from "@/components/shared/overview/OverviewComponent.vue";
import AddChecklistDialog from "@/components/checklists/children/AddChecklistDialog.vue";

export default Vue.extend({
  data: () => ({
    data: [] as Array<unknown>,
    headers: [] as Array<HeaderObject>,
    loading: true,
    totalPages: 0,
    totalItemCount: -1,
    defaultSortBy: ["createdDate"],
    defaultSortDesc: [true],
    contactPersons: [],
    users: [],
    tradeCodes: [],
    projects: [],
    showAddChecklist: false,
    checklistProjectId: null,
  }),
  mounted() {
    this.getFilterData();
  },
  methods: {
    async fetchData({ data, bottomOfPage }) {
      this.loading = true;

      await checkListApi
        .getChecklists(data)
        .then((response: any) => {
          if (bottomOfPage) {
            this.data = [...this.data, ...response.items];
          } else {
            this.data = response.items;
          }

          this.totalPages = response.totalPages;
          this.totalItemCount = response.totalItemCount;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getFilterData() {
      checkListApi.getFilteroptions().then((response) => {
        this.contactPersons = response.contactPersons;
        this.users = response.users;
        this.tradeCodes = response.tradeCodes;
        this.projects = response.projects;
      });
    },
    clickCard(item: any) {
      this.$router.push({ name: "checklist", params: { id: item.id } });
    },
    getChips(item: any) {
      var data = [
        {
          title:
            item.itemsCompletedCount + "/" + item.itemsTotalCount + " Fullført",
          color:
            item.itemsCompletedCount === item.itemsTotalCount
              ? "success"
              : "warning",
        },
        {
          title: item.completedDate ? "Fullført" : "Ikke fullført",
          color: item.completedDate ? "success" : "warning",
        },
      ];

      return data;
    },
    setColor(item: any) {
      this.$set(item, "color", item.completedDate ? "success" : "warning");
    },
    setHeader() {
      this.headers = [
        {
          text: "Id",
          value: "id",
          type: "string",
          show: true,
          filterValues: "",
          filterClause: 0,
          filterName: "id",
        },
        {
          text: "Tittel",
          value: "name",
          type: "string",
          show: true,
          filterValues: "",
          filterClause: 0,
          filterName: "name",
        },
        {
          text: "Fullført",
          value: "isCompleted",
          type: "boolean",
          show: true,
          filterValues: "false",
          filterClause: 0,
          filterName: "isCompleted",
        },
        {
          text: "Frist",
          value: "deadline",
          type: "date",
          show: true,
          filterValues: "",
          filterClause: 0,
          filterName: "deadline",
          dateType: "DD.MM.YYYY",
        },
        {
          text: "Prosjekt",
          value: "projectName",
          type: "string",
          show: true,
          filterValues: "",
          filterClause: 0,
          filterName: "projTable",
        },

        {
          text: "Bygg",
          value: "houseName",
          type: "string",
          show: true,
          filterValues: "",
          filterClause: 0,
          filterName: "houseName",
        },
        {
          text: "Seksjon",
          value: "projSectionApartNum",
          type: "string",
          show: true,
          filterValues: "",
          filterClause: 0,
          filterName: "projSectionApartNum",
          removeFilter: true,
        },
        {
          text: "Ansvarlig",
          value: "assignedTo",
          type: "string",
          show: true,
          filterValues: this.showAllActions ? "" : this.profile.id,
          filterClause: 0,
          filterName: "assignedContactPersonId",
          disabled: this.showAllActions ? false : true,
          isAssignedTo: true,
        },
        {
          text: "Fagområde",
          value: "tradeCodeName",
          type: "string",
          show: true,
          filterValues: "",
          filterClause: 0,
          filterName: "tradeCodeId",
        },
        {
          text: "Opprettet",
          value: "createdDate",
          type: "date",
          show: true,
          filterValues: null,
          filterClause: 0,
          filterName: "createdDate",
          dateType: "DD.MM.YYYY",
        },
      ];
    },
    addChecklist() {
      var projects = this.tableHeaders.headers.find(
        (x) => x.filterName === "projTable"
      ).filterValues;
      this.checklistProjectId = projects[0];
      this.showAddChecklist = true;
    },
  },

  computed: {
    ...mapGetters({
      isTrysilhus: "shared/isTrysilhus",
      profile: "shared/profile",
      showAll: "tables/showAll",
      tableHeaders: "tables/tableHeaders",
    }),
    showAllActions(): boolean {
      return this.showAll.value;
    },
    subtitle(): string {
      return this.showAllActions && this.isTrysilhus
        ? "Alle sjekklister"
        : "Dine sjekklister";
    },
  },
  components: {
    OverviewComponent,
    AddChecklistDialog,
  },
});
</script>
